import React from "react";

import * as types from "types";
import UserPic from "assets/userPic.svg?react";
import CopyButton from "./CopyButton";
import styles from "./Message.module.scss";
import Markdown from "../Markdown";

interface MessageUserProps {
  content: types.Message["content"];
}

/**
 * Represents a chat message.
 * Memoized to avoid <ReactMarkdown /> running too often.
 */
export default React.memo(function MessageUser({ content }: MessageUserProps) {
  return (
    <div className={styles.messageContainer}>
      <span className={styles.messageRole}>user</span>
      <div className={styles.message}>
        {/* Display picture */}
        <div className={`${styles.displayPic} user`}>
          <UserPic className={styles.userPic} />
        </div>
        {/* Role and message content */}
        <div className={`${styles.messageContent} user`}>
          <CopyButton content={content} />
          <Markdown content={content} />
        </div>
        <div className={styles.avatarSpacer} aria-hidden="true" />
      </div>
    </div>
  );
});
